var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProfileImageNewCircular(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 71,
    viewBox: "0 0 70 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.0001 70.7197C54.3301 70.7197 70 55.0497 70 35.7198C70 16.3898 54.3301 0.719727 35.0001 0.719727C15.6701 0.719727 0 16.3898 0 35.7198C0 55.0497 15.6701 70.7197 35.0001 70.7197Z",
    fill: "#BCBEC0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8191 34.3398H29.7891V36.6798H40.8191V34.3398Z",
    fill: "#E66433"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1289 30.0002V41.0303H36.4689V30.0002H34.1289Z",
    fill: "#E66433"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileImageNewCircular);
export default __webpack_public_path__ + "static/media/profile_image_new_circular.41d516d6d74a488b89836c0b745e12e9.svg";
export { ForwardRef as ReactComponent };